module.exports = __webpack_public_path__ + "img/6.018f8521.png";